import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from "react-router-dom";
import { badAccountsSelector, useOptimistReportSelector } from "./state";
const BadAccounts = () => {
    const badAccounts = useOptimistReportSelector(state => badAccountsSelector(state));
    return (_jsx("div", { className: "flex flex-wrap-reverse gap-2", children: badAccounts.map(({ account, creditManager }) => (_jsx(Link, { to: `#${creditManager}_${account}`.toLowerCase(), className: "text-red-700", children: account }, account))) }));
};
export default BadAccounts;
